// rea-import.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';

import { environment } from '../../../environments/environment';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import { FincaReaRequest, HistoricoREAModel, ReaImportData } from 'src/app/models/fincas/rea.model';


@Injectable({ providedIn: 'root' })
export class ReaImportService {

  private readonly importEndpoint: string = `${environment.serverUrl}/ws/index.php?p1=fincas&p2=importREA`;
  private readonly lastRegisterEndpoint: string = `${environment.serverUrl}/ws/index.php?p1=fincas&p2=getLastRegisterREA`;

  constructor(private readonly http: HttpClient) {}

  public importRea(payload: FincaReaRequest): Observable<BaseResponseModel<ReaImportData>> {
    return this.http.post<unknown>(this.importEndpoint, payload).pipe(
      map((resp) => BaseResponseModel.normalize<ReaImportData>(resp)),
      catchError((error: unknown) => of(BaseResponseModel.fromError<ReaImportData>(error, 'Error inesperado al importar REA'))),
    );
  }// ();

  public getLastRegisterRea(codigoREA: string): Observable<BaseResponseModel<HistoricoREAModel>> {
    const params = new HttpParams().set('codigo_REA', codigoREA);

    return this.http.get<unknown>(this.lastRegisterEndpoint, { params }).pipe(
      map((resp) => BaseResponseModel.normalize<HistoricoREAModel>(resp)),
      catchError((error: unknown) => of(BaseResponseModel.fromError<HistoricoREAModel>(error, 'Error inesperado al consultar histórico REA'))),
    );
  }// ();
}// class;
